const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-epub-viewer'] = {
        c: () => require('partner/modules/moe-epub-viewer/moe-epub-viewer.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-epub-viewer',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-epub-viewer'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-epub-viewer|moe-epub-viewer'] = {
                c: () => require('partner/modules/moe-epub-viewer/moe-epub-viewer.view.tsx'),
                cn: '__local__-__local__-moe-epub-viewer'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };